import script from "./EmpireWargamesView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmpireWargamesView.vue?vue&type=script&setup=true&lang=js"

import "./EmpireWargamesView.vue?vue&type=style&index=0&id=2380eb1e&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2380eb1e"]])

export default __exports__